const EXTENSION_POINT = 'WebPixel::Render';

export { EXTENSION_POINT };
